import { AwsRum } from "aws-rum-web";
import { getAwsRumConfig } from "./config";

export type RumSession = {
  awsRum: AwsRum | undefined;
  sessionId: string | undefined;
};

let rumSession: RumSession | undefined;

const createRumSession = (): RumSession => {
  const session: RumSession = { awsRum: undefined, sessionId: undefined };
  try {
    console.log("Will setup AWS Rum");
    const awsRum = getAwsRumConfig();
    awsRum.addPlugin({
      getPluginId: () => "FrontendAnalyticsIntegration",
      load: (context) => {
        session.sessionId = context.getSession()?.sessionId;
      },
      enable: () => {},
      disable: () => {},
    });
    session.awsRum = awsRum;
  } catch (error) {
    console.error(error);
  }
  return session;
};

export const getRumSession = (): RumSession => {
  if (!rumSession) {
    rumSession = createRumSession();
  }
  return rumSession;
};
